import { render, staticRenderFns } from "./ModalUserProfile.vue?vue&type=template&id=50814681&"
import script from "./ModalUserProfile.vue?vue&type=script&lang=js&"
export * from "./ModalUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports